import React from 'react';
import BasePrintingColorChooser from 'components/quote_builder_widget/shared/BasePrintingColorChooser';
import styles from './_style.module.scss';

const PrintingColorChooser = ({ widgetIdentifier, cartonMaterialUserPriceId }) => {
  return (
    <BasePrintingColorChooser
      widgetIdentifier={widgetIdentifier}
      cartonMaterialUserPriceId={cartonMaterialUserPriceId}
      styles={styles}
      selectClassName={`${styles.input} ${styles.inputWithoutSuffix}`}
    />
  );
};

export default PrintingColorChooser;
